export { ApplicantAvatar } from './ApplicantAvatar';
